import React, { Component } from 'react';
import { defaultHeaders } from './util';
import * as util from "./util";
import {
  ProductRating, ProductDetailsButtons, ProductMedia,
  ProductReviews, ProductDescriptionService, ProductReferenceService, ProductSoftwareNew, CommUserInfo
,ProductTypeWithoutParantheses, ProductPrice, ProductTypeWithLabel} from './product-details';
import {Header} from './header.js';
import {Footer} from './footer.js';
import './product-details.css';
import { CategoryPathWithLabel } from './show-categorypath.js';



let faqProductDetails = [
  {
    content: "Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",
    title: "Nicht fündig geworden?",
    key: 0
  }
];


export class NewServiceDetails extends Component {
  constructor(props) {
    super(props);
    this.getNewServiceDetails = this.getNewServiceDetails.bind(this);

    this.state = {
      type: 'Dienstleistung',
      id: this.props.match.params['id'],
      name: '',
      board: '',
      uuid: '',
      description: '',
      references: '',
      categories: '',
      customer_reference: '',
      warrantor: '',
      expertise: '',
      price_from: '',
      price_to: '',
      pdf_file: '',
      tags: '',
      agreement: '',
      agb_agreement: ''
    };

    if (!util.isCommercialUser() && !util.isNonCommercialUser() && this.id !== undefined) {
      util.loginGuest( () => this.getNewServiceDetails(this.props.match.params['id']) );
    } else {
      this.getNewServiceDetails(this.props.match.params['id']);
    }
  }

  componentWillReceiveProps(nextProps) {
    const newID = parseInt(nextProps.match.params['id'], 10);
    const oldID = parseInt(this.state.id, 10);
    if (oldID !== newID) {
      this.getNewServiceDetails(newID);
      this.setState({ id: newID });
    }
  }

  getNewServiceDetails(productID) {
    const self = this;
    const url = `/api/show-service?id=${productID}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        console.error('Could not service details.', exception);
      });

    promise.then(function (json) {
      localStorage.setItem('product-name', json.name);
      self.setState({
        name: (json.name ? json.name : '(kein Name)'),
        board: json.board ? json.board : '',
        uuid: json.uuid ? json.uuid : '',
        description: (json.description ? json.description : '(keine Angabe)'),
        references: (json.references ? json.references : '(keine Angabe)'),
        categories: (json.categories ? json.categories : '(keine Angabe)'),
        customer_reference: (json.customer_reference ? json.customer_reference : '(keine Angabe)'),
        warrantor: (json.warrantor ? json.warrantor : '(keine Angabe)'),
        expertise: (json.expertise ? json.expertise : '(keine Angabe)'),
        price_from: (json.price_from !== undefined ? json.price_from : '(keine Angabe)'),
        price_to: (json.price_to !== undefined ? json.price_to : '(keine Angabe)'),
        pdf_file: (json.pdf_file ? json.pdf_file : '(keine Angabe)'),
        tags: (json.tags ? json.tags : '(keine Angabe)'),
        agreement: (json.agreement ? json.agreement : '(keine Angabe)'),
        agb_agreement: (json.agb_agreement ? json.agb_agreement : '(keine Angabe)'),
      });
      return;
    });
    return;
  }
  render() {
    return (
      <div className="Landing" id="contentId">
      <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
      <div className="ContentWithBackground">
      <div className="content" id="content">
            <div className="productHeader1">
             {/*  <ProductType name={this.state.name} productType={this.state.type} />*/}
              <ProductTypeWithoutParantheses name={this.state.name} />
            </div>
           
            <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price_from} price2={this.state.price_to} onNewMessage={this.props.onNewMessage} />
  
            <div className="productInfoHeader">
            {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
        <CommUserInfo id={this.props.match.params['id']} table={"service"}/>
        <ProductTypeWithLabel  productType={this.state.type} />
              <CommUserInfo id={this.state.id} table={"document"}/>
              <CategoryPathWithLabel ids={this.state.categories} startID={2} />
              {/* <CategoryPath ids={this.state.categories} startID={2} /> */}
              <ProductRating uuid={this.state.uuid} />
              {!util.isGuestUser() && <ProductPrice price={this.state.price} />}
            </div>
      
        <ProductTabsService
            onNewMessage={this.props.onNewMessage}
            uuid={this.state.uuid}
            productID={this.state.id}
            description={this.state.description}
            expertise={this.state.expertise}
            tags={this.state.tags}
            pdf_file={this.state.pdf_file}
            customer_reference={this.state.customer_reference}
            warrantor={this.state.warrantor}
            references={this.state.references} />
        <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price_from} price2={this.state.price_to} onNewMessage={this.props.onNewMessage} />
        </div>
        </div>
        <Footer faqs={faqProductDetails}/>
      </div>
    );
  }
}

class ProductTabsService extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
      <div className="ProductTabs">
        <div className="ProductTabsButtons">
          <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
          <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Referenz</button>
          <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} >ref. Software</button>
          <button className={this.state.activeTab === 3 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(3)} >Medien</button>
          <button className={this.state.activeTab === 4 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(4)} >Reviews</button>
          <ProductDescriptionService style={this.state.activeTab === 0 ? null : { display: 'none' }}
                                     description={this.props.description}
                                     service_expertise={this.props.expertise}
                                     tags={this.props.tags} />
          <ProductReferenceService style={this.state.activeTab === 1 ? null : { display: 'none' }}
                                   service_customer_reference={this.props.customer_reference}
                                   warrantor={this.props.warrantor} />
          <ProductSoftwareNew style={this.state.activeTab === 2 ? null : { display: 'none' }}
                              referenced_software={this.props.references} />
          <ProductMedia style={this.state.activeTab === 3 ? null : { display: 'none' }}
                        uuid={this.props.pdf_file}/>
          <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 4 ? null : { display: 'none' }}
                          onNewMessage={this.props.onNewMessage} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/new-show-service.js